import { gql } from "apollo-boost"

export const GET_ACTIVITY_ASSISTANTS_BY_AGE_RANGE = gql`
  query projectAssistantsByAgeRange ($submissionId:ID!, $lowerRange: Float!, $highestRange: Float!) {
    projectAssistantsByAgeRange (submissionId: $submissionId, lowerRange: $lowerRange, highestRange: $highestRange) {
      specificObjectiveId
      specific_objective_order_index
      activity_id
      activity_order_index
      no_gender_count
      male_count
      female_count
      total_count
    }
  }
`
